import { register } from '@forter/core';
import { FcSortControl } from './FcSortControl.js';

register(FcSortControl);
